<form id="commission-rule-form" class="modal-panel side-panel-modal-form" [formGroup]="form">
    <modal-panel [title]="ruleDetail ? 'Edit Commission Rule' : 'New Commission Rule'" (close)="handleClose()">

        <div id="commission-rule-main-container">
            <div>
                <div>
                    <mat-form-field>
                        <mat-label>Rule Name</mat-label>
                        <input matInput formControlName="ruleName">
                    </mat-form-field>
                </div>

                <div>
                    <mat-form-field>
                        <mat-label>Description</mat-label>
                        <textarea matInput formControlName="description"></textarea>
                    </mat-form-field>
                </div>

                <div>
                    <mat-form-field>
                        <mat-label>Rule Criteria</mat-label>
                        <mat-select formControlName="criteriaId">
                            @for (c of criteria; track c.id) {
                                <mat-option [value]="c.id">{{ c.name }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="row-fields">
                    <mat-form-field class="half-width">
                        <mat-label>Priority (lower = first)</mat-label>
                        <input matInput type="number" formControlName="priority">
                    </mat-form-field>

                    <mat-form-field class="half-width">
                        <mat-label>Auto-Fix Delay (min)</mat-label>
                        <input matInput type="number" formControlName="autoFixDelayMinutes">
                    </mat-form-field>
                </div>

                <div>
                    <mat-form-field>
                        <mat-label>Action Type</mat-label>
                        <mat-select formControlName="actionTypeId">
                            @for (at of actionTypes; track at.id) {
                                <mat-option [value]="at.id">{{ at.name }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>

                <div>
                    <mat-form-field>
                        <mat-label>Rule Expression (RulesEngine lambda)</mat-label>
                        <textarea matInput formControlName="expression" rows="3"
                                  placeholder='e.g. input1.Rate != input1.Agent.SplitRate'></textarea>
                    </mat-form-field>
                </div>

                <div>
                    <mat-form-field>
                        <mat-label>Expected Value Expression (optional)</mat-label>
                        <textarea matInput formControlName="expectedValueExpression" rows="2"
                                  placeholder='e.g. Agent.SplitRate'></textarea>
                    </mat-form-field>
                </div>

                <div class="mb-16">
                    <h3>Conditions</h3>
                    <div formArrayName="conditions">
                        @for (condition of conditions.controls; track $index) {
                            <div [formGroupName]="$index" class="condition-row">
                                <mat-form-field class="condition-field">
                                    <mat-label>Entity</mat-label>
                                    <input matInput formControlName="entityName"
                                           [placeholder]="uiComponents[$index]?.entityName || ''">
                                </mat-form-field>

                                <mat-form-field class="condition-field">
                                    <mat-label>{{ uiComponents[$index]?.label || 'Column' }}</mat-label>
                                    <input matInput formControlName="entityColumn"
                                           [placeholder]="uiComponents[$index]?.entityColumn || ''">
                                </mat-form-field>

                                <mat-form-field class="condition-operator">
                                    <mat-label>Operator</mat-label>
                                    <mat-select formControlName="operatorId">
                                        @for (op of operators; track op.id) {
                                            <mat-option [value]="op.id">{{ op.displayName }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field class="condition-field">
                                    <mat-label>Value</mat-label>
                                    <input matInput formControlName="value">
                                </mat-form-field>

                                <button mat-icon-button color="warn" (click)="removeCondition($index)" type="button">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        }
                    </div>
                    <button mat-stroked-button color="primary" (click)="addCondition()" type="button">
                        <mat-icon>add</mat-icon> Add Condition
                    </button>
                </div>

                <div class="mb-24">
                    <mat-label>Rule State</mat-label>
                    <br/>
                    <mat-slide-toggle formControlName="enabled" class="mt-8 mr-16">
                        {{ form.controls['enabled'].value ? 'ENABLED' : 'DISABLED' }}
                    </mat-slide-toggle>
                    <mat-slide-toggle formControlName="paused" class="mt-8">
                        {{ form.controls['paused'].value ? 'PAUSED' : 'ACTIVE' }}
                    </mat-slide-toggle>
                </div>
            </div>
        </div>

        <ng-container modalPanelFooter>
            <div class="items-space-between">
                <button class="col-md-3" mat-raised-button color="warn" type="button" (click)="handleClose()">Cancel</button>
                <button class="col-md-3" mat-raised-button color="primary" type="submit" (click)="applyRule()" [disabled]="form.invalid">
                    {{ ruleDetail ? 'Update' : 'Create' }}
                </button>
            </div>
        </ng-container>
    </modal-panel>
</form>
